import { useLocalStorage } from '@rehooks/local-storage';
export default function useRxConditionId() {
  return useLocalStorage('rx_condition_id', '');
}
